import React from "react";
import PropTypes from "prop-types";
import Link from "./Link";
import trackEvent from "theme/modules/Analytics/trackEvent";

const TrackingLink = ({ eventName, eventPayload, ...props }) => {
  return (
    <Link {...props} onClick={(e) => trackEvent(eventName, eventPayload)}>
      {props.children}
    </Link>
  );
};

TrackingLink.propTypes = {
  ...Link.propTypes,
  eventName: PropTypes.string.isRequired,
  eventPayload: PropTypes.object.isRequired,
};

export default TrackingLink;
